import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('gdpr.data_collection_rules.view.table.rule');

type Props = {
  recipient: string;
};

export default function EmailRecipient(props: Props) {
  return <div>{t(`options.${props.recipient}`)}</div>;
}
